import { render } from "./ChangePassword.vue?vue&type=template&id=281f6656&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=281f6656&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-281f6656"

export default script